// The tenant's `displayConfig.theme`, as the two questions the components actually ask of it.
//
// - `default` (brownsbs, gabihairandnails): paper. Light cards on a light page.
// - `futuristic` (herevr): dark, and lit with neon in the tenant's primary colour: glowing
//   edges, a running light round the hero card, a pulsing selected slot.
// - `dark` (2fadedbarbershop): dark like `futuristic`, with none of its neon. Where that theme
//   glows, this one draws a hairline in the primary colour and a plain black shadow.
//
// Everything that is about the page being dark (surfaces, ink, the gradient lettering) asks
// `isDarkTheme`; only the glow asks `isNeonTheme`. Every colour comes from the tenant row.
const DARK_THEMES = ["futuristic", "dark"];

export const isDarkTheme = (displayConfig) => DARK_THEMES.includes(displayConfig?.theme);

export const isNeonTheme = (displayConfig) => displayConfig?.theme === "futuristic";
